import api from '../api';

import { uploadComposeSuccess } from './compose';

export function searchGifs(query, offset = 0) {
  return async () => {
    const params = new URLSearchParams({ offset: String(offset) });
    if (query) params.set('q', query);
    const response = await api().get(`/api/v2/gifs/search?${params.toString()}`);
    return response.data;
  };
}

export function attachGif(gifId) {
  return async (dispatch) => {
    const response = await api().post('/api/v2/gifs/attach', { id: gifId });
    dispatch(uploadComposeSuccess(response.data, null));
    return response.data;
  };
}
